<template>
    <div>
        <FilePond
            name="prueba"
            ref="pond"
            :maxFiles="maxFiles"
            allowMultiple="true"
            acceptedFileTypes="image/jpeg, image/png"
            :server="{  process, revert,  restore, load, fetch }"
            v-bind:files="files"
                />
    </div>
</template>

<script>
    import FilePond, { registerPlugin } from 'vue-filepond';

    // Register a plugin
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
    registerPlugin(FilePondPluginFileValidateType);
    registerPlugin(FilePondPluginFileValidateSize);

    // Import FilePond styles
    import 'filepond/dist/filepond.min.css';


    export default {
        name: "file-uploader",
        props: ['text', 'maxFiles'],
        data: function() {
            return {
            files: [], };
        },
        methods: {
            process  (fieldName, file, metadata, load, error, progress, abort)  {
                try {
                    console.log("esto esta funcionando?")
                    progress(true, 0, 1024);
                    var uploadTask = this.$storage.ref().child('images/' + (new Date().getTime()) + 'a' + file.name).put(file, metadata)
                    uploadTask.on(this.$firebase.storage.TaskEvent.STATE_CHANGED,
                        function (snapshot) {
                            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                            console.log('Upload is ' + progress + '% done')
                            //progress(true, snapshot.bytesTransferred, snapshot.totalBytes)
                        }, function (e) {
                            switch (e.code) {
                                case 'storage/canceled':
                                    break;
                                default: error(e.message)
                            }
                        }, function () {
                            load(uploadTask.snapshot.ref.fullPath)
                        })
                    console.log(uploadTask)
                    return {
                        abort: () => {
                            abort()
                            uploadTask.cancel();
                        }
                    }
                } catch (e) {
                    error(e.message)
                    return {
                        abort: () => {
                            abort()
                        }
                    }
                }
            },
            revert (uniqueFileId, load, error) {
                // Create a reference to the file to delete
                console.log(uniqueFileId)
                var desertRef = this.$storage.ref().child(uniqueFileId);
                        desertRef.delete().then(function() {
                            load();
                        }).catch(function(e) {
                            error('oh my goodness');
                        });
            },
            load (uniqueFileId, load, error){
                console.log('loading')
                error()
            },
            fetch (url, load, error, progress, abort, headers) {
               error("Solo archivos locales")
            },
            restore (uniqueFileId, load, error, progress, abort, headers) {
                error()
            }
        },
        watch:{
            files () {
                this.$emit('upload', this.files)
            }
        },
        components: {
            FilePond
        }
    }
</script>

